<template>
    <div class="content">
        <div>
            <div class="page" v-show="index==0">
                <div class="title">外保人员信息登记</div>
                <van-form :show-error-message="false" :scroll-to-error="true" @submit="onSubmit">
                    <div class="tit">*请选择入职门店</div>
                    <van-cell-group inset>
                    <van-field
                        v-model="shopName"
                        is-link
                        readonly
                        name="picker"
                        placeholder="点击选择门店"
                        @click="showPicker = false"/>
                    <van-popup v-model="showPicker" position="bottom">
                        <van-picker
                        :show-toolbar="true"
                        :columns="columns"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                        />
                    </van-popup>
                </van-cell-group>
                <div class="tit">请输入手机号</div>
                <van-field v-model="form.mobile" name="mobile" placeholder="请输入手机号" :rules="telRules2"/>
                <div style="margin: 0.6rem 0;">
                    <van-button round block type="primary" native-type="submit" :loading="loading">
                    开始填写
                    </van-button>
                </div>
                </van-form>
            </div>
            <div class="page" v-show="index==1">
                <div class="title">外保人员信息登记</div>
                <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
                <div class="tmt">基本信息</div>
                <div class="txt"><i>*</i>1.姓名</div>
                <van-field v-model="form.outsidersName" name="outsidersName" placeholder="请输入姓名" :rules="[{ required: true, message: '请输入姓名' }]"/>
                <div class="txt"><i>*</i>2.身份证类型</div>
                <van-field name="idCardType" class="noborder">
                    <template #input>
                    <van-radio-group v-model="form.idCardType">
                        <van-radio name="1">身份证</van-radio>
                        <van-radio name="2">护照</van-radio>
                    </van-radio-group>
                    </template>
                </van-field>
                <div class="txt"><i>*</i>3.{{form.idCardType==1?'身份证号':'护照号'}}</div>
                <van-field v-model="form.idCardNo" @input="getidcard" name="idCardNo" :placeholder="'请输入'+(form.idCardType==1?'身份证':'护照')+'号'" :rules="telRules3"/>
                <div class="txt" v-show="form.idCardType==2"><i>*</i>护照签发开始日期</div>
                <van-field v-show="form.idCardType==2" readonly clickable name="issueDate" :value="form.issueDate" placeholder="请选择护照签发日期" :rules="[{ required: true, message: '请选择护照签发日期' }]" @click="getshowPicker3" />
                <van-popup v-model="showPicker3" position="bottom" v-show="form.idCardType==2">
                <van-datetime-picker
                    v-model="currentDate1"
                    type="date"
                    :min-date="minDate"
                    :max-date="maxDate1"
                    @confirm="onConfirmtwo3"
                    @cancel="showPicker3 = false"/>
                </van-popup>
                <div class="txt" v-show="form.idCardType==2"><i>*</i>护照签发结束日期</div>
                <van-field v-show="form.idCardType==2" readonly clickable name="expireDate" :value="form.expireDate" placeholder="请选择护照结束日期" :rules="[{ required: true, message: '请选择护照签发日期' }]" @click="getshowPicker4" />
                <van-popup v-model="showPicker4" position="bottom" v-show="form.idCardType==2">
                <van-datetime-picker
                    v-model="currentDate2"
                    type="date"
                    :min-date="minDate"
                    :max-date="maxDate1"
                    @confirm="onConfirmtwo4"
                    @cancel="showPicker4 = false"/>
                </van-popup>
                <div class="txt">4.性别</div>
                <van-field name="sex" class="noborder">
                    <template #input>
                    <van-radio-group v-model="form.sex">
                        <van-radio name="1">男</van-radio>
                        <van-radio name="2">女</van-radio>
                    </van-radio-group>
                    </template>
                </van-field>
                <div class="txt">5.民族</div>
                <van-field v-model="form.nationality" name="formNation" placeholder="请输入民族"/>
                <div class="txt">6.生日</div>
                <van-field readonly clickable name="date" :value="form.birthday" placeholder="请选择生日" @click="getshowPicker" />
                    <van-popup v-model="showPicker1" position="bottom">
                    <van-datetime-picker
                        v-model="currentDate"
                        type="date"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="onConfirmtwo"
                        @cancel="showPicker1 = false"/>
                    </van-popup>
                <div class="txt">7.身高(cm)</div>
                <van-field v-model="form.height" type="digit" placeholder="请输入身高" />
                <div class="txt">8.手机号</div>
                <van-field v-model="form.mobile" name="formMobile" placeholder="请输入手机号" :rules="telRules2"/>
                <div class="txt">9.学历</div>
                <van-cell-group inset>
                    <van-field
                        v-model="form.qualificationName"
                        is-link
                        readonly
                        name="picker"
                        placeholder="点击选择学历"
                        @click="showPicker2 = true"/>
                    <van-popup v-model="showPicker2" position="bottom">
                        <van-picker
                        :show-toolbar="true"
                        :columns="columns2"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                        />
                    </van-popup>
                </van-cell-group>
                <div class="txt">10.籍贯</div>
                <van-field v-model="form.nativePlace" name="nativePlace" placeholder="请输入籍贯"/>
                <div class="txt" v-if="form.idCardType==1">11.身份证地址</div>
                <van-field v-if="form.idCardType==1" v-model="form.idAddress" name="idAddress" placeholder="请输入身份证地址"/>
                <div class="txt">{{form.idCardType==1?12:11}}现住址</div>
                <van-field v-model="form.currentAddress" name="currentAddress" placeholder="请输入现住址"/>
                <div style="margin: 0.6rem 0;">
                    <van-button round block type="primary" native-type="submit" :loading="loading">
                    下一步
                    </van-button>
                </div>
                </van-form>
            </div>
            <div class="page" v-if="index==3">
                <div class="boximg flexcenter">
                  <img src="@/assets/suc.png"/>
                  <div class="text">
                      <div class="btit flexcenter">提交成功</div>
                      <p>感谢您的提交</p>
                      <div style="width:150px">
                        <van-button round block type="primary" @click="index=0">退 出</van-button>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const form = {
  age:'',
  birthday:'',
  currentAddress:'',
  entryDate:'',
  expireDate:'',
  height:'',
  idAddress:'',
  idCardNo:'',
  idCardType:1,
  issueDate:'',
  mobile:'',
  nationality:'',
  nativePlace:'',
  outsidersName:'',
  outsidersNo:'',
  outsidersType:'1',
  qualification:'',
  qualificationName:'',
  sex:'',
  shopSid:'',
  sid:''
}
export default {
  name: 'outuser',
  data () {
    return {
      index:0,
      loading:false,
      showPicker:false,
      showPicker1:false,
      showPicker2:false,
      showPicker3:false,
      showPicker4:false,
      shopName:'',
      form: Object.assign({}, form),
      columns:['101', '102'],
      columns2:['小学', '初中', '中专', '高中', '大专', '大学', '研究生'],
      currentDate:new Date(),
      minDate: new Date(1942, 0, 1),
      maxDate: new Date(2025, 10, 1),
      maxDate1: new Date(2050, 10, 1),
      currentDate1:'',
      currentDate2:'',
      currentDate3:'',
      shoplist:[],
      telRules2:[{
        required: true,
        message: '请输入手机号',
        trigger: 'onBlur'
      }, {
        validator: value => {
            return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)
        },
        message: '手机号格式不正确',
        trigger: 'onBlur'
      }],
      telRules3:[{
        required: true,
        message: '请输入身份证号',
        trigger: 'onBlur'
      }
      // , {
      //   validator: value => {
      //       return /^\d{6}(((19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}([0-9]|x|X))|(\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}))$/.test(value)
      //   },
      //   message: '身份证号格式不正确',
      //   trigger: 'onBlur'
      // }
      ],
      type:1,
      shopSid:101,
    }
  },
  created(){
    document.title = '外保人员管理'
    let url=window.location.href
    var temp1 = url.split('?');
    this.shopSid=this.$route.params.shopSid
    this.getshop()
  },
  methods:{
    getshop(){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getAllShopList",'').then((res) => {
        if(res.status==200){
          that.shoplist=res.data.shopList
          if(res.data.shopList.length>0){
            let index = res.data.shopList.findIndex(item => item.value === '100')
            if(index>-1){
              that.shoplist.splice(index, 1)
            }
            if(that.shoplist.length>0 && this.type==1){
              let nindex = that.shoplist.findIndex(item => item.value == that.shopSid)
              that.shopName=that.shoplist[nindex].text
            }
          }
        }
      }).catch((error) =>{
      });
    },
    getidcard(id){
      if(this.form.idCardType==1){
        var re = /^\d{6}(((19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}([0-9]|x|X))|(\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}))$/;
        if(re.test(id)){
          let birth=id.substring(6, 10) + "-" + id.substring(10, 12) + "-" + id.substring(12, 14);
          var myDate = new Date();
          var age = myDate.getFullYear() - id.substring(6, 10) - 1;
          var sec=id.substring(16,17)
          var sex=sec%2==0?'2':'1'
          var provinces = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
          var province = provinces[parseInt(id.substr(0, 2))];
          this.form.sex=sex
          this.form.birthday=birth
          this.form.nativePlace=province
        }
      }
    },
    onConfirm2(value,index){
      this.form.qualification=index+1
      this.form.qualificationName=value
      // this.guide.educationCode=index+1
      this.showPicker2=false
    },
    getnewdata(){
      let nowDate = new Date();
      let month= nowDate.getMonth() + 1;
      let date = {
        year: nowDate.getFullYear(),
        month:month<10? '0'+month:month,
        date: nowDate.getDate()<10?'0'+nowDate.getDate():nowDate.getDate(),
      }
      this.data = date.year + " 年 "+date.month +" 月 "+ date.date+" 日";
    },
    getshowPicker(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate=new Date(year,Month,day)
      this.showPicker1=true
    },
    onConfirmtwo(time) {
        this.form.birthday=this.getDate(time);
        this.showPicker1 = false;
    },
    getshowPicker3(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate1=new Date(year,Month,day)
      this.showPicker3=true

    },
    onConfirmtwo3(time){
      this.form.issueDate=this.getDate(time);
      this.showPicker3 = false;
    },
    getshowPicker4(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate2=new Date(year,Month,day)
      this.showPicker4=true

    },
    onConfirmtwo4(time){
      this.form.expireDate=this.getDate(time);
      this.showPicker4 = false;
    },
    onConfirm (value){
      this.shopName=value.text
      this.form.shopSid=value.value
      this.showPicker=false
    },
    onSubmit(values){
      let that=this
      that.loading=true
      that.$axios.get(process.env.API_HOST+"sysmanager/vue/outsiders/mobile?mobile="+that.form.mobile).then((res) => {
          that.loading=false
          console.log(res.data)
          if(res.data.state==200){
            if(res.data.data && res.data.data!=''){
              let birthday=res.data.data.birthday?res.data.data.birthday.split(" ")[0]:''
              that.form=res.data.data || Object.assign({}, form)
              that.form.birthday=birthday
              that.form.idCardType=that.form.idCardType?that.form.idCardType.toString():''
              that.form.qualificationName=that.columns2[Number(that.form.qualification)-1]
              that.index=1
            }else{
              let mobile=JSON.parse(JSON.stringify(that.form.mobile))
              that.form=res.data.data || Object.assign({}, form)
              that.form.mobile=mobile
              that.index=1
            }
            
          }else{
            this.$toast(res.data.message);
          }
        }).catch((error) =>{
          that.loading=false
        });
    },
     //提交用户信息
    goSubmit(values){
      let that=this
      that.loading=true
      if(that.form.sid && that.form.sid!=''){
        that.form.shopSid=that.shopSid
        that.form.shopSidList=[that.shopSid]
        that.$axios.put(process.env.API_HOST+"sysmanager/vue/outsiders/msg",that.form).then((res) => {
          that.loading=false
          if(res.data.state==200){
            that.index=3
          }else{
            this.$toast(res.data.message);
          }
        }).catch((error) =>{
          that.loading=false
        });
      }else{
        that.form.shopSid=that.shopSid
        that.form.shopSidList=[that.shopSid]
        that.$axios.post(process.env.API_HOST+"sysmanager/vue/outsiders/msg",that.form).then((res) => {
          that.loading=false
          if(res.data.state==200){
            that.index=3
          }else{
            this.$toast(res.data.message);
          }
        }).catch((error) =>{
          that.loading=false
        });
      }
      
    },
    getDate(date){
        var time = new Date(date);
        var year= time.getFullYear()  //年
        var month = ("0" + (time.getMonth() + 1)).slice(-2); //月
        var day = ("0" + time.getDate()).slice(-2); //日
        var mydate = year + "-" + month + "-" + day;
        return mydate
    },
  }
}
</script>

<style scoped>
.page{
  box-sizing: border-box;
  padding: 0 0.4rem 0;
  /* padding: 0 0.4rem 90px; */
}
canvas{
  width: 50vh !important;
}
.formfoot{
  padding-bottom:100px;
}
.page .title{
    font-size: 20px;
		color: #0096FF;
		font-weight: 600;
    margin: 1rem 0.5rem;
    text-align: center;
}
.tit{
  font-size: 14px;
  color: #0096FF;
  font-weight: 600;
  margin: 0.4rem 0 0.3rem;
}
.tmt{
  font-size: 16px;
  margin: 0.4rem 0;
  border-left: 3px solid #0096FF;
  box-sizing: border-box;
  padding-left: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tmt img{
  width: 0.7rem;
  height: 0.7rem;
  box-sizing: border-box;
  padding: 0.1rem;
}
.txt{
  font-size: 14px;
  margin: 0.4rem 0 0.3rem;
}
.txt i{
  color: red;
  font-size: 18px;
  font-style: normal;
  margin-right: 5px;
  position: relative;
  top: 3px;
}
.fixdbottom{
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 20px;
  left: 0;
}
.btn{
   width: 100%;
    box-sizing: border-box;
    padding: 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btn .van-button{
  width: 45%;
}
.fixdbottom .van-button{
  width: 48%;
}
.promise{
  padding: 0;
}
.promise .protit{
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  box-sizing: border-box;
  padding: 0.9rem 0.4rem 0.7rem;
}
.promise .probox{
  padding: 0 0.4rem;
}
.promise p{
  font-size: 18px;
  margin: 0 0 5px;
  line-height: 160%;
}
.promise img{
  width: 135px;
  display: block;
  margin: 10px 0 20px 2em;
}
.prodate{
  text-align: right;
  box-sizing: border-box;
  padding-bottom: 0.7rem;
}
.indent{
  text-indent: 2em;
}
.widbox{
  position: relative;
}
.widbox i{
  position: absolute;
  top: 0;
  right: 0;
  font-style: normal;
  font-size: 14px;
  border-radius: 0 0 0 12px;
  background: rgba(0, 0, 0, .7);
  text-align: center;
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  line-height: 22px;
  color: #fff;
}
.flexcenter{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.boximg{
  box-sizing: border-box;
  padding: 90px 25px;
}
.boximg img{
  width: 90px;
  height: 90px;
  margin-bottom: 20px;
}
.boximg .btit{
  font-size: 24px;
  font-weight: bold;
}
.boximg p{
  line-height: 160%;
  font-size: 18px;
  text-align: center;
}
.boximg .text{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.van-button--primary{
  background-color: #0096FF;
  border-color: #0096FF;
}
.van-cell-group--inset{
  margin: 0;
  border:1px solid #ebedf0;
  border-radius: 0.1rem;
}
.van-cell-group--inset .van-cell{
  border: none;
}
.van-cell{
  border:1px solid #ebedf0;
  border-radius: 0.1rem;
}
.foot .van-button{
  margin: 20px 0;
}
.foot .van-checkbox{
  margin: 30px 0;
}
.tipss{
  color: rgba(69,90,100,.6);
  font-size: 14px;
}
>>>.van-search{
  position: fixed;
  top: 40%;
  left: 0;
  width: 100%;
  z-index: 999;
}
>>> .van-search__content{
  padding-left: 0;
}
>>> .van-list{
  position: absolute;
  top: 1.5rem;
  left: 0;
  width: 100%;
}
>>> .van-search .van-cell{
  padding-left: 12px;
}
>>> .van-cell::after,>>> .van-hairline--top-bottom::after, >>> .van-hairline-unset--top-bottom::after,.noborder{
  border: none;
}
>>> .van-checkbox__label{
  font-size: 18px;
}
>>> .van-checkbox__icon .van-icon{
  border-radius: 4px;
}
.esignTest{
  width: 100%;
  height: 100%;
}
>>> .van-field__control{
  display: block;
  width: 100%;
}
>>> .van-radio-group{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
>>> .van-radio+.van-radio{
  margin-left:10px;
}
>>> .van-uploader{
  width: 100%;
}
>>> .van-uploader__wrapper{
  width: 100%;
  height: 0;
  padding-top: 60.2%;
  box-sizing: border-box;
  margin: 0;
}
>>> .van-uploader__upload{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
}
>>> .van-button--disabled{
  opacity: .3;
}
/* .zm >>>.van-uploader__upload{
  background: url('http://116.196.116.98:4869/52193ed8a175ad5dcd07fbf227cdee59?f=png') no-repeat center;
  background-size:contain;
}
.fm >>>.van-uploader__upload{
  background: url('http://116.196.116.98:4869/35b620480fcefb70d8674d447bb54691?f=png') no-repeat center;
  background-size:contain;
} */
/* .zm >>>.van-uploader__upload-icon,.zm >>>.van-uploader__upload-text,.fm >>>.van-uploader__upload-icon,.fm >>>.van-uploader__upload-text{
  display: none;
} */
>>> .van-radio__label--disabled{
  color: #323233;
}
>>> .van-radio__icon--disabled .van-icon{
  background-color: #fff;
}
>>> .van-radio__icon--checked .van-icon{
      color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
>>> .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
>>> .van-checkbox__label--disabled{
  color: #323233;
}
>>> .van-picker-column__item--selected{
  background: #ddd;
}
</style>


// WEBPACK FOOTER //
// src/view/outuser.vue